import { render } from "./polizas.vue?vue&type=template&id=ba7a6472&scoped=true"
import script from "./polizas.vue?vue&type=script&lang=js"
export * from "./polizas.vue?vue&type=script&lang=js"

import "./polizas.vue?vue&type=style&index=0&id=ba7a6472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7a6472"]])

export default __exports__